/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const FixtureLikeParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
]);
export class FixtureLike extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return FixtureLikeParser.decode(input).map(res => new FixtureLike(res));
    }
    static unsafeDecode(input) {
        return FixtureLike.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FixtureLikeParser.encode(data);
    }
    static schema() {
        return FixtureLikeParser.schema();
    }
}
